export const handleScroll = (section: string) => {
  const scrollSection = document.getElementById(section);
  if (scrollSection) {
    scrollSection.scrollIntoView({ behavior: "smooth" });
  }
};
